export const REFERRAL_IN_SOURCE = "referral-in";

export const isReferralInSupportingInfo = (item = {}) => {
  const text = [
    item?.category,
    item?.code,
    item?.codeText,
    item?.code_text,
    item?.value,
    item?.reason,
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();

  return text.includes("reason-for-visit") && text.includes("referral");
};

export const hasReferralInSupportingInfo = (items = []) =>
  Array.isArray(items) && items.some(isReferralInSupportingInfo);

export const referralInSupportingInfo = () => ({
  category: "reason-for-visit",
  code: "referral",
  codeText: "Reason for visit",
  source: REFERRAL_IN_SOURCE,
});

export const withReferralInSupportingInfo = (items = []) => {
  const nextItems = Array.isArray(items) ? [...items] : [];
  if (hasReferralInSupportingInfo(nextItems)) {
    return nextItems;
  }
  return [...nextItems, referralInSupportingInfo()];
};

export const withoutAutoReferralInSupportingInfo = (items = []) =>
  Array.isArray(items)
    ? items.filter((item) => item?.source !== REFERRAL_IN_SOURCE)
    : [];
